import { render, staticRenderFns } from "./WPBaseSwitchItem.vue?vue&type=template&id=029a238a"
import script from "./WPBaseSwitchItem.vue?vue&type=script&lang=ts"
export * from "./WPBaseSwitchItem.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseSwitchItem.vue?vue&type=style&index=0&id=029a238a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports